import React from 'react';

function demoModal (props) { 
       
          return(
                    <div style={{marginTop: "5px"}}>
                        <video width="510" height="300" controls>
                          <source src="https://tfai-studio.s3.amazonaws.com/techforceRPA_version2.mp4" type="video/mp4"/>
                        </video> 
                        <div>
                            <button className="popup-btn" onClick={()=>props.showModal()} >
                                Dont Show Again
                            </button>
                        </div>
                    </div>
          )
}
export default demoModal;